module.exports = __webpack_public_path__ + "img/img-7.b89ec22b.png";